import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LoginService } from 'src/app/services/login.service';
import { UsersService } from 'src/app/services/users.service';
import { UsersV2Service } from 'src/app/services/users-v2.service';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
})
export class UserComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<UserComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { id: number | 'novo' },
    private loginService: LoginService,
    private usersService: UsersService,
    private usersV2Service: UsersV2Service
  ) {}

  title = 'Cadastrar usuário';

  fg = new UntypedFormGroup({
    id: new UntypedFormControl(null),
    cpf: new UntypedFormControl(null, [Validators.required]),
    name: new UntypedFormControl(null, [Validators.required]),
    birthdate: new UntypedFormControl(null, [Validators.required]),
    mobile: new UntypedFormControl(null, [Validators.required]),
    email: new UntypedFormControl(null, [Validators.required]),
    function: new UntypedFormControl(null, [Validators.required]),
  });

  functions = ['Administrador', 'Assistente'];

  loading = false;
  checkingCPF = false;

  ngOnInit(): void {
    if (this.data.id !== 'novo') {
      this.title = 'Editar usuário';
      this.load();
    } else {
      this.fg.disable();
      this.fg.controls.cpf.enable();
    }
  }

  load() {
    this.loading = true;
    this.usersService.getUserById(Number(this.data.id)).subscribe(
      (res) => {
        this.onApplyData(res.data);
      },
      () => {
        this.loading = false;
        this.loginService.showMessage('Erro ao buscar usuário', 3000);
        this.dialogRef.close();
      }
    );
  }

  onApplyData(user) {
    this.fg.patchValue({
      id: user.id,
      cpf: user.cpf,
      name: user.name,
      birthdate: user.birthdate,
      mobile: user.mobile,
      email: user.email,
      function: user.function,
    });

    this.fg.controls.cpf.disable();
    this.loading = false;
  }

  async onChangeCPF() {
    this.checkingCPF = true;
    const cpfForm = this.fg.controls.cpf;
    const cpfValue = cpfForm.value;
    cpfForm.disable();

    if (!this.loginService.isCpfPatternValid(cpfValue)) {
      cpfForm.enable();
      cpfForm.setErrors({
        invalid: true,
      });
      this.checkingCPF = false;
      return;
    }

    if (await this.usersService.userExist(cpfValue).toPromise()) {
      cpfForm.enable();
      cpfForm.setErrors({
        alreadyExist: true,
      });
      this.checkingCPF = false;
      return;
    }

    this.loginService.showMessage('CPF válido. Continue com o cadastro do usuário', 4000);
    this.checkingCPF = false;
    this.fg.enable();
  }

  public onChangeEmail() {
    if (!this.loginService.isEmailPatternValid(this.fg.controls.email.value)) {
      this.fg.controls.email.setErrors({
        invalid: true,
      });
    }
  }

  public save() {
    if (this.fg.invalid) {
      this.loginService.showMessage('Preencha os campos corretamente', 3000);
      return;
    }

    this.loading = true;
    const raw = this.fg.getRawValue();

    if (!raw.id) {
      this.usersV2Service.createUser(raw).subscribe(
        () => {
          this.loginService.showMessage('Usuário salvo com sucesso', 3000);
          this.dialogRef.close({ success: true });
        },
        (error) => {
          this.loading = false;
          const msg =
            error?.error?.message || error?.message || 'Erro ao salvar dados, tente novamente';

          if (
            error?.status === 409 &&
            String(msg).toLowerCase().includes('usuário já cadastrado')
          ) {
            this.fg.controls.cpf.setErrors({ alreadyExist: true });
            this.fg.controls.email.setErrors({ alreadyExist: true });
          }

          if (
            error?.status === 400 &&
            String(msg).toLowerCase().includes('cpf do usuário inválido')
          ) {
            this.fg.controls.cpf.setErrors({ invalid: true });
          }

          this.loginService.showMessage(msg, 3000);
        }
      );
    } else {
      this.usersService.createUserInAccount(raw).subscribe(
        () => {
          this.loginService.showMessage('Usuário salvo com sucesso', 3000);
          this.dialogRef.close({ success: true });
        },
        (error) => {
          this.loading = false;
          const msg =
            error?.error?.message || error?.message || 'Erro ao salvar dados, tente novamente';

          if (error?.status === 409 && String(msg).toLowerCase().includes('e-mail já cadastrado')) {
            this.fg.controls.email.setErrors({ alreadyExist: true });
          }

          this.loginService.showMessage(msg, 3000);
        }
      );
    }
  }
}
